// Centralized helper to build asset URLs (logos, avatars, photos, invoices…)
// served from /uploads via the backend.
//
// In production (custom domain like resawork.fr), the backend is reverse-proxied
// on the same origin → use window.location.origin
// In preview / localhost dev, use REACT_APP_BACKEND_URL
//
// Without this fix, production users see 404 because the URL still points to
// the old preview URL stored at build time in REACT_APP_BACKEND_URL.

export function getApiBase() {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  const host = window.location.hostname;
  const isLocalOrPreview =
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.includes('preview.emergentagent.com');
  return isLocalOrPreview
    ? (process.env.REACT_APP_BACKEND_URL || '')
    : window.location.origin;
}

// Build a full URL for any uploaded asset (logo, avatar, photo, invoice…).
// Accepts:
//   - absolute http(s) URL → returned as-is
//   - "/uploads/foo.jpg"   → prefixed with API base + "/api"
//   - other relative paths → returned as-is (likely already full path)
export function getAssetUrl(url) {
  if (!url) return null;
  if (typeof url !== 'string') return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('data:')) return url; // base64 inline
  if (url.startsWith('/uploads')) {
    return `${getApiBase()}/api${url}`;
  }
  return url;
}

// Aliases for readability at call sites
export const getLogoUrl = getAssetUrl;
export const getAvatarUrl = getAssetUrl;
export const getPhotoUrl = getAssetUrl;
export const getInvoiceUrl = getAssetUrl;
